import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";

type actions = "added" | "removed" | "updated";

interface MxChangeLogAddAndRemoveArrowProps {
  label: string;
  changes: {
    items: string;
    action: actions;
  }[];
}

const getAction = (actions: actions) => {
  if (actions == "added") return "Agregado";
  if (actions == "removed") return "Removido";
  if (actions == "updated") return "Actualizado";
};

export const MxChangeLogAddAndRemoveArrow = (
  props: MxChangeLogAddAndRemoveArrowProps
) => {
  return (
    <Grid container>
      <Grid container my={0.5} rowGap={1} px={1}>
        {props.label && (
          <Grid container item xs={12}>
            <MxTypography variant="caption" color="primary.main" fontWeight={600}>
              {props.label}
            </MxTypography>
          </Grid>
        )}

        <Grid container rowGap={1} px={1}>
          {props.changes.map(x => (
            <Grid container item xs={12} rowGap={1} py={0.5}>
              <Grid item xs={12}>
                <MxTypography
                  variant="caption"
                  color="primary.main"
                  fontWeight={500}
                  width={"auto"}
                >
                  {getAction(x.action)}
                </MxTypography>
              </Grid>

              <Grid item xs={12}>
                <MxTypography
                  variant="caption"
                  color="grey.700"
                  fontWeight={300}
                  width={"auto"}
                  dangerouslySetInnerHTML={{
                    __html: x.items || "Sin información"
                  }}
                ></MxTypography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
